import React from 'react';
import { Grid } from '@material-ui/core';
import {
  StyledCaptions,
  ItemWrapper,
  ContentWrapper,
  StyledIcon,
  StyledSmallIcon,
} from 'components/ListBoxItem/styles';
import { AssuranceIcon } from 'images';
import { IntlShape, injectIntl } from 'react-intl';
import { darkBlue, white } from 'Material-UI/colors';
import { connect } from 'react-redux';
import messages from 'containers/AmcDetailsPage/messages';
import { createStructuredSelector } from 'reselect';
import { translate } from 'helpers/intl';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

type ListBoxItemType = {
  items: any;
  isBeneficiaryBloc?: boolean;
  intl: IntlShape;
};
const ListBoxItem = ({ ...props }: ListBoxItemType) => {
  const client =
    props.items &&
    props.items.filter((beneficiary: any) =>
      beneficiary.categorie.includes('AS'),
    );
  const partners =
    props.items &&
    props.items.filter((beneficiary: any) =>
      beneficiary.categorie.includes('C'),
    );
  const childs =
    props.items &&
    props.items.filter(
      (beneficiary: any) =>
        !beneficiary.categorie.includes('AS') &&
        !beneficiary.categorie.includes('C'),
    );

  return (
    <>
      <Grid spacing={1} container>
        {props.isBeneficiaryBloc && (
          <Grid item xs={6} sm={4} lg={2}>
            <ItemWrapper coloredBackground={true} data-testid="menu_item">
              <ContentWrapper>
                <HelpOutlineIcon style={{ color: white }} />
                <StyledCaptions weight="500" color={'white'}>
                  {translate({ ...messages.howAddBenificiary }, props)}
                </StyledCaptions>
              </ContentWrapper>
            </ItemWrapper>
          </Grid>
        )}
        {client &&
          client.map(
            (
              item: {
                path: string;
                icon: string;
                title: string;
                smalIcon?: Boolean;
                category: string;
                label: string;
                categorie: string;
              },
              index: number,
            ) => (
              <Grid item xs={6} sm={4} lg={2} key={index}>
                <ItemWrapper coloredBackground={false} data-testid="menu_item">
                  <ContentWrapper>
                    {item.smalIcon ? (
                      <StyledSmallIcon src={AssuranceIcon[item.icon]} />
                    ) : (
                      <StyledIcon src={AssuranceIcon[item.icon]} />
                    )}
                    <StyledCaptions weight="500" color={darkBlue}>
                      {item.title}
                    </StyledCaptions>
                  </ContentWrapper>
                </ItemWrapper>
              </Grid>
            ),
          )}
        {partners &&
          partners.map(
            (
              item: {
                path: string;
                icon: string;
                title: string;
                smalIcon?: Boolean;
                category: string;
                label: string;
                categorie: string;
              },
              index: number,
            ) => (
              <Grid item xs={6} sm={4} lg={2} key={index}>
                <ItemWrapper coloredBackground={false} data-testid="menu_item">
                  <ContentWrapper>
                    {item.smalIcon ? (
                      <StyledSmallIcon src={AssuranceIcon[item.icon]} />
                    ) : (
                      <StyledIcon src={AssuranceIcon[item.icon]} />
                    )}
                    <StyledCaptions weight="500" color={darkBlue}>
                      {item.title}
                    </StyledCaptions>
                  </ContentWrapper>
                </ItemWrapper>
              </Grid>
            ),
          )}
        {childs &&
          childs.map(
            (
              item: {
                path: string;
                icon: string;
                title: string;
                smalIcon?: Boolean;
                category: string;
                label: string;
                categorie: string;
              },
              index: number,
            ) => (
              <Grid item xs={6} sm={4} lg={2} key={index}>
                <ItemWrapper coloredBackground={false} data-testid="menu_item">
                  <ContentWrapper>
                    {item.smalIcon ? (
                      <StyledSmallIcon src={AssuranceIcon[item.icon]} />
                    ) : (
                      <StyledIcon src={AssuranceIcon[item.icon]} />
                    )}
                    <StyledCaptions weight="500" color={darkBlue}>
                      {item.title}
                    </StyledCaptions>
                  </ContentWrapper>
                </ItemWrapper>
              </Grid>
            ),
          )}
      </Grid>
    </>
  );
};

const mapStateToProps = createStructuredSelector<any, {}>({});

export default connect(mapStateToProps)(injectIntl(ListBoxItem));
export { ListBoxItem };
